import { render } from "./RevueCulturePage.vue?vue&type=template&id=1a7a041e"
import script from "./RevueCulturePage.vue?vue&type=script&lang=js"
export * from "./RevueCulturePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__